const routes = [
  {
    path: '/personGroup', // 人员群组管理
    name: 'personGroup',
    component: () => import('./pages/Home'),
    redirect: '/personGroup/index',
    meta: {
      requireAuth: false
    },
    children: [
      {
        path: 'index',
        name: 'personGroupIndex',
        component: () => import('./pages/index'),
        meta: {
          requireAuth: false,
          routerAlive: true
        }
      }
    ]
  }
]

export default routes